/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';

/**
 * Balance DTO
 */
export interface BalanceBackofficeDto {
  accountId?: number;
  assetId?: number;
  asset?: Asset;
  total?: number;
  credit?: number;
  tradingEnabled: boolean;
  free?: number;
}
